<template>
  <page-outline :title="$t('Webheader.annuaire_file')">
    <template slot="pageContent">
      <b-container fluid>
        <div class="requestsList">
          <div class="mt-0">
            <div>
              <b-row class="text-xl-start justify-content-start">
                <b-col xl="4" lg="6" md="6" cols="12">
                  <b-button-group class="my-3 mt-sm-0">
                    <b-button class="px-4" :variant="tabName === 1 ? 'primary btn-selected' : ''" @click="changeTabName(1)">{{ $t('Webheader.annuaire_client') }}</b-button>
                    <b-button class="px-4" :variant="tabName === 2 ? 'primary btn-selected' : ''" @click="changeTabName(2)">{{ $t('Webheader.annuaire_file') }}</b-button>
                  </b-button-group>
                </b-col>
                <b-col cols="6" lg="4" xl="2" class="p-0">
                  <b-button class="mb-3 justify-item-end" v-if="canAddAnnuaireFile && !activateSpinner"
                            @click="addAnnuaireFile" variant="primary">
                    <i class="fa-light fa-plus "></i>
                    <span>{{$t('annuaire.add_annuaire_file')}}</span>
                  </b-button>
                </b-col>
              </b-row>

              <AnnuaireLineList v-if="tabName === 1" :type="TrackType" :id="id"></AnnuaireLineList>
              <AnnuaireFilePage v-if="tabName === 2"></AnnuaireFilePage>
            </div>
          </div>
        </div>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import AnnuaireFilePage from "@/pages/annuaire/AnnuaireFilePage.vue";
import AnnuaireLineList from "@/pages/annuaire/AnnuaireLineList.vue";
import {loadPage} from "@/helpers/routing";


export default {
  name: 'AnnuairePage',
  components: {
    AnnuaireLineList,
    AnnuaireFilePage,
    'page-outline': PageOutline,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    fields () {
      let fields
      if (this.tabName == 1){
        fields = [
          { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), class: 'text-center', sortable: false },
          { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
          { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
          { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
          { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
          { key: 'TestedData', label: this.$i18n.t('tracking.tested_data'), class: 'text-center', sortable: false },
          { key: 'Result', label: this.$i18n.t('tracking.maching_result'), class: 'text-center', sortable: false }
        ]
      }
      else{
        fields = [
          { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), class: 'text-center', sortable: false },
          { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
          { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
          { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
          { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
          { key: 'Name', label: this.$i18n.t('tracking.name'), class: 'text-center', sortable: false },
          { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: false },
        ]
      }

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.IBAN ||
          this.BIC ||
          this.dateBegin || this.dateEnd) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      idTrackAcc: '',
      statusVerification: '',
      mode: 1,
      tabName: 1,
      identifier: '',
      technicalStatus: '',
      BIC: '',
      IBAN: '',
      dateBegin: '',
      returnUrl: '',
      dateEnd: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      trackActive: '',
      TracksList: [],
      TrackType: ''
    }
  },
  created () {
    if (this.id !== 'NULL'){
      this.tabName = parseInt(this.id)
    }
    this.$bus.$emit('switch-selected-menu', '/annuaire/')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.tracking.cleanFilterCondition()
  },
  methods: {
    canAddAnnuaireFile () {
      return this.$engine.rights.rightIs('annuaire_file_add', true)
    },
    addAnnuaireFile () {
      let that = this
      loadPage(that, {url: '/annuaireform/create/'})
    },
    changeTabName (tabName) {
      this.tabName = tabName
    }
  }
}
</script>
